




























import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbShopAccount,  TbSettingsPad,TbNotice } from '@/http';
import { NumberKeyboard } from "@/components";
import { Toast } from 'vant';
import xpInfo from "./xpInfo.vue";
import dpInfo from "./dpInfo.vue";
import xpSetting from "./xpSetting.vue";
import dpSetting from "./dpSetting.vue";
@Component({ 
    components: {
        NumberKeyboard,xpInfo,dpInfo,xpSetting,dpSetting
    },
})
export default class pjSetting extends Vue {
   
    public $refs: {
    };

    tabList=[
        {
            label:'小票打印机',
            value:1,
            values:[1,3],
        },
        {
            label:'吊牌打印机',
            value:2,
            values:[2,4],
        },
    ];

    active=1;
    xpActive=1;
    dpActive=1;
    
    created() {
        
    }

    async mounted(){
    }
    
    chooseTab(item){
        if((this.active==1||this.active==3)&&item.value==2){
            localStorage.removeItem('isnewLabel')   
        }
        else if((this.active==2||this.active==4)&&item.value==1){
            localStorage.removeItem('isnewReceipt')   
        }
        this.active = item.value;
    }
    changeTab(val){
        this.active = val.tabActive;
        if(val.tabActive==1||val.tabActive==3){
            this.xpActive = val.childActive;
        }else{
            this.dpActive = val.childActive;
        }
        
    }
    beforeDestroy() {
        localStorage.removeItem('isnewLabel')   
        localStorage.removeItem('isnewReceipt')   
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/pjSetting.vue